/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Facet} from "../facets/facet"
import {HDF_SUBREAD_FRAME} from "../frames/hdf-subread"
import { multisort, desc, valueToDate } from "../../core/utils/property-sort"

export const HDF_SUBREAD_FACET = new Facet({
    frame: HDF_SUBREAD_FRAME,
    defaultColumns: [
        "id", "name", "runName", "cellIndex", "numRecords", "totalLength",
        "createdAt"],
    initialSort: multisort(desc(valueToDate("updatedAt")), desc(valueToDate("createdAt"))),
    additionalColumns: [
        "cellId", "instrumentName", "wellName", "wellSampleName", "bioSampleName",
        "plateId", "jobId", "uuid", "path", "updatedAt",
        "tags", "projectId", "version", "md5", "createdBy", "comments",
        "metadataContextId"],
    displayProperties: [
        "name", "runName", "cellIndex", "numRecords", "totalLength",
        "createdAt", "instrumentName", "wellName", "wellSampleName",
        "bioSampleName", "plateId", "jobId", "id", "uuid", "path", "updatedAt",
        "tags", "projectId", "version", "md5", "createdBy", "comments",
        "metadataContextId"]
})
